import { useUpdateLifeArea } from 'features/life-areas';
import { useLifeAreaById } from 'features/life-areas/hooks/use-life-area-by-id';
import { useCallback } from 'react';
import { DocumentOrganizationKeys } from 'shared/types/filter-document';
import { ID } from 'shared/types/id';
import { GroupByMode } from 'shared/types/sorting-mode';
import { v4 as uuidv4 } from 'uuid';

export const useCreateLifeAreaSection = (lifeAreaId?: ID) => {
  const lifeArea = useLifeAreaById(lifeAreaId);
  const { submit: updateLifeArea } = useUpdateLifeArea();

  return useCallback(() => {
    if (!lifeArea?.id) {
      return;
    }

    const sections = lifeArea.sections ?? [];

    updateLifeArea({
      id: lifeArea.id,
      sections: [
        ...sections,
        {
          id: uuidv4(),
          name: '',
          tasks: [],
          createdAt: new Date(),
        },
      ],
      filterDocument: {
        ...(lifeArea.filterDocument ?? {}),
        [DocumentOrganizationKeys.GroupByMode]: GroupByMode.Section,
      },
    });
  }, [
    lifeArea?.filterDocument,
    lifeArea?.id,
    lifeArea?.sections,
    updateLifeArea,
  ]);
};
